<template>
  <card-edit-property
    :goto-edit-next="gotoEditNextFormatted"
    :existing-property-id="existingPropertyId"
    :goto-report-id-next="gotoReportNextFormatted"
  />
</template>

<script lang="ts">
import CardEditProperty from '@/components/CardEditProperty.vue'

export default {
  name: 'NewDevelopmentView',
  components: { CardEditProperty },
  props: {
    gotoEditNext: {
      type: String as () => string | null,
      description:
        'If set to true, the user will be redirected to finish editing a report after creating a new property',
      default: null
    },
    existingPropertyId: {
      required: false,
      type: String as () => string | null,
      description: 'The ID of the existing property to edit',
      default: null
    },
    gotoReportIdNext: {
      type: String as () => string | null,
      description:
        'If set to a value, the user will be redirected to view that report after updating the custom property',
      default: null
    }
  },
  computed: {
    gotoEditNextFormatted() {
      return this.gotoEditNext === 'true'
    },
    gotoReportNextFormatted() {
      if (this.gotoReportIdNext) {
        return parseInt(this.gotoReportIdNext)
      }
      return null
    }
  }
}
</script>
